import { render, staticRenderFns } from "./OrderlineoverviewPage.vue?vue&type=template&id=37e13bc4"
import script from "./OrderlineoverviewPage.vue?vue&type=script&lang=js"
export * from "./OrderlineoverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports